export const taskReponse = [
    { id: '1qw', description: 'Разработали архитектуру, готовы показать.', offer: 7777 }
];
